export enum UpgradeSpacePlanType {
  'maxCapacity' = 'maxCapacity',
  'payCapacity' = 'payCapacity',
  'maxGuestCount' = 'maxGuestCount',
  'maxFileSize' = 'maxFileSize',
  'subscribeAiLimit' = 'subscribeAiLimit',
  'maxCopyLimit' = 'maxCopyLimit',
}
